export default __webpack_public_path__ + "static/media/RockinTuna-BG-m-2x.5c255015.jpg";